// Segment 4 — Gear Check
import { useState } from 'react';
import { Check } from 'lucide-react';
import AccordionBlock from '@/components/AccordionBlock';

const ITEMS = [
  { key: 'claude_workspace', label: "Logged into your organization's Claude workspace" },
  { key: 'platform_tab',    label: 'This platform open in a second tab' },
  { key: 'pod_steward',     label: "You know your pod's steward" },
];

const GearItem = ({ item }) => {
  const storageKey = `ai_lab_gear_${item.key}`;
  const [checked, setChecked] = useState(() => localStorage.getItem(storageKey) === 'true');

  const toggle = () => {
    const next = !checked;
    localStorage.setItem(storageKey, String(next));
    setChecked(next);
  };

  return (
    <button
      onClick={toggle}
      data-testid={`gear-item-${item.key}`}
      className={`w-full flex items-center gap-5 p-6 rounded-2xl border-2 text-left transition-all ${
        checked
          ? 'bg-brand-teal/5 border-brand-teal'
          : 'bg-white border-black/10 hover:border-brand-orange/50'
      }`}
    >
      <span
        className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 border-2 transition-colors ${
          checked ? 'bg-brand-teal border-brand-teal' : 'border-gray-300'
        }`}
      >
        {checked && <Check size={18} className="text-white" strokeWidth={3} />}
      </span>
      <span
        className={`text-lg font-medium leading-snug ${
          checked ? 'text-brand-teal line-through opacity-60' : 'text-ink'
        }`}
      >
        {item.label}
      </span>
    </button>
  );
};

const Segment4 = () => (
  <div>
    <h1 className="text-4xl md:text-5xl font-bold text-ink mb-8 leading-tight">Gear Check</h1>

    <div className="space-y-3 max-w-xl mb-10" data-testid="gear-checklist">
      {ITEMS.map((item) => (
        <GearItem key={item.key} item={item} />
      ))}
    </div>

    <div className="max-w-xl">
      <AccordionBlock title="Workspace won't load?">
        <div className="space-y-3 pt-1 text-sm text-ink-secondary leading-relaxed">
          <p>
            <strong className="text-ink">Right now:</strong> Open{' '}
            <a
              href="https://claude.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-orange underline underline-offset-2"
            >
              claude.ai
            </a>{' '}
            — the free tier works for today's exercises. You won't miss anything.
          </p>
          <p>
            <strong className="text-ink">Tonight:</strong> Your steward will send redemption codes
            for the full workspace. Keep their number handy.
          </p>
        </div>
      </AccordionBlock>
    </div>
  </div>
);

export default Segment4;
